(function(){
  document.addEventListener("click", e => {
    const btn = e.target.closest('[name="checkout"]');
    if (!btn) return;

    // 이미 팝업에서 checkout 진행 중이면 통과
    if (window.__HGW_GOING_CHECKOUT__) return;

    e.preventDefault();

    HGW.core.open(() => {
      // 🔒 다시 intercept 되는 것 방지
      window.__HGW_GOING_CHECKOUT__ = true;

      // ✅ form submit ❌
      // btn.form.submit(); ❌

      // ✅ JS redirect ⭕
      window.location.assign("/checkout");
    });
  });
})();
